import { MDTailwindMinPixelBreakpointWidth } from '../../util/theme.util';
import { StandardBusinessForm, StandardBusinessFormVisibilityOptions, useBusinessForm } from '../../Business';
import { SideOverHeaderNew, SideOverHeading, SideOverFooter, ElementsButton } from '../components';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from 'react-use';

interface BusinessFormSideOverPageProps {
  firmID: string;
  clientID: string;
  isLoading: boolean;
  exitRoute: string | undefined;
  visibilityOptions?: StandardBusinessFormVisibilityOptions;
  useBusinessFormReturn: ReturnType<typeof useBusinessForm>;
}

export function BusinessFormSideOverPage({
  firmID,
  clientID,
  exitRoute,
  isLoading,
  visibilityOptions,
  useBusinessFormReturn,
}: BusinessFormSideOverPageProps) {
  const { t: tCommon } = useTranslation('common');
  const { width: windowWidth } = useWindowSize();

  return (
    <>
      <SideOverHeaderNew exit={exitRoute} withShadow className="!px-4" exitText={tCommon('cancel')} />
      <div className="md:px-10 px-4">
        <SideOverHeading heading={tCommon('business')} />
        <StandardBusinessForm
          firmID={firmID}
          clientID={clientID}
          className="mb-28 md:mb-36"
          visibilityOptions={visibilityOptions}
          useBusinessFormReturn={useBusinessFormReturn}
        >
          <SideOverFooter>
            <ElementsButton
              icon="check"
              iconPosition="left"
              isLoading={isLoading}
              label={tCommon('save')}
              size={windowWidth < MDTailwindMinPixelBreakpointWidth ? 'small' : 'large'}
            />
          </SideOverFooter>
        </StandardBusinessForm>
      </div>
    </>
  );
}
